import { Button, LuIcon, Text } from "@overmap-ai/blocks"
import { selectAssetTypeById } from "@overmap-ai/core"
import { getRouteApi, Link } from "@tanstack/react-router"
import { memo } from "react"

import { AssetTypeIcon } from "../../components/Icons/AssetTypeIcon"
import { modelIconMapping } from "../../mappings/icons"
import { useAppSelector } from "../../store"
import { BaseTopBar } from "../TopBars/BaseTopBar"

const routeApi = getRouteApi("/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/statuses")

export const AssetTypeSettingsStatusViewTopBar = memo(() => {
	const { assetTypeId } = routeApi.useParams()

	const assetType = useAppSelector(selectAssetTypeById(assetTypeId))!

	return (
		<BaseTopBar
			showAIButton={false}
			leftContent={
				<Link
					from="/$organizationId/settings/asset-types/$assetTypeId/statuses"
					to="/$organizationId/settings/asset-types/$assetTypeId"
				>
					<Button>
						<LuIcon icon={modelIconMapping.arrowLeft} />
						<AssetTypeIcon assetTypeId={assetTypeId} />
						<Text>{assetType.name}</Text>
					</Button>
				</Link>
			}
		/>
	)
})
AssetTypeSettingsStatusViewTopBar.displayName = "AssetTypeSettingsStatusViewTopBar"
